import { useState } from "react"
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ProjectsOnlineMode from "./ProjectsOnlineMode";
import ProjectsOfflineMode from "./ProjectsOfflineMode";
import ProjectsInDraftList from "./ProjectsInDraftList";
import ShowProjectReport from "../../pages/showProjectReport/ShowProjectReport";

const Projects = () => {
    const [value, setValue] = useState(0);
    const theme = useTheme();



    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeIndex = (index) => {
        setValue(index);
    };

    function a11yProps(index) {
        return {
            id: `action-tab-${index}`,
            'aria-controls': `action-tabpanel-${index}`,
        };
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (

            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`action-tabpanel-${index}`}
                aria-labelledby={`action-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3}>{children}</Box>}
            </Typography>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    return (

        <div className="TabBar-container" >
            <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="action tabs example"
                >
                    <Tab label="ثبت پروژه" {...a11yProps(0)} />
                    <Tab label="گزارش پروژه ها" {...a11yProps(1)} />
                    <Tab label="ثبت پروژه آفلاین" {...a11yProps(2)} />
                    <Tab label="پیش نویس ها" {...a11yProps(3)} />
                </Tabs>
            </AppBar>





            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    {/* online project components */}
                    < ProjectsOnlineMode />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    {/* online project components */}
                    < ShowProjectReport />
                </TabPanel>

                <TabPanel value={value} index={2} dir={theme.direction}>
                    {/* offline project components */}
                    <ProjectsOfflineMode />
                </TabPanel>

                <TabPanel value={value} index={3} dir={theme.direction}>
                    {/* offline project list in draft */}
                    <ProjectsInDraftList />
                </TabPanel>
            </SwipeableViews>


        </div>
    )
}

export default Projects